import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ENVIRONMENT } from '@cfp/core';
import { LoginCard } from '@cfp/shared/ui/login';
import { Button, Icon, InputText, Link } from '@cfp/ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PasswordService } from 'csr-login-app';
import { LoginLoadingSpinner, LoginMessages } from '../../components';
import { LoginFormService } from '../../services';

@Component({
  selector: 'cfp-forgot-password-page',
  templateUrl: './forgot-password-page.html',
  imports: [
    LoginCard,
    LoginLoadingSpinner,
    TranslateModule,
    LoginMessages,
    ReactiveFormsModule,
    InputText,
    Link,
    RouterLink,
    Button,
    Icon
  ]
})
export class ForgotPasswordPage {
  protected loading: boolean = false;
  protected formSubmitSuccess: boolean = false;
  protected locale: string;
  protected form: FormGroup;
  protected successMessages: string[] = [];
  protected warningMessages: string[] = [];
  protected errorMessages: string[] = [];

  protected readonly environment = inject(ENVIRONMENT);
  private readonly loginFormService = inject(LoginFormService);
  private readonly fb = inject(FormBuilder);
  private readonly translateService = inject(TranslateService);
  private readonly passwordService = inject(PasswordService);

  constructor() {
    const group: any = {
      username: ['', Validators.required]
    };

    this.form = this.fb.group(group);

    this.locale = this.translateService.currentLang;
  }

  protected submitForm(): void {
    if (this.validateForm()) {
      this.loading = true;

      this.passwordService
        .v2PasswordForgotpasswordPost({
          username: this.form.value.username,
          environmentCode: this.environment.environmentCode.dto
        })
        .subscribe({
          next: () => {
            this.loading = false;
            this.successMessages = ['login.success.requestPasswordReset'];
            this.formSubmitSuccess = true;
          },
          error: () => {
            this.loading = false;
          }
        });
    }
  }

  private validateForm(): boolean {
    if (this.form.status === 'INVALID') {
      this.errorMessages = this.loginFormService.transformErrorMessages(this.form);
      return false;
    } else {
      this.errorMessages = [];
      return true;
    }
  }
}
